import { ProjectDrillingParameterBase } from './base/project-drilling-parameter-base';

export class ProjectDrillingParameter extends ProjectDrillingParameterBase { }